import { theme } from '@/theme'
import {
  Building2,
  Car,
  Coins,
  Euro,
  Home,
  Laptop,
  Monitor,
  Package,
  Scale,
  Truck,
  Umbrella,
} from 'lucide-react'

const getIcon = (category: string) => {
  switch (category) {
    case 'LI':
      return Umbrella
    case 'CO':
      return Package
    case 'LE':
      return Scale
    case 'CA':
      return Car
    case 'BU':
      return Building2
    case 'RE':
      return Home
    case 'CY':
    case 'MI':
      return Laptop
    case 'TR':
      return Truck
    case 'EL':
      return Monitor
    case 'FL':
      return Coins
    default:
      return Euro
  }
}

interface CategoryIconProps {
  categoryId: string
}

export const CategoryIcon = ({ categoryId }: CategoryIconProps) => {
  const Icon = getIcon(categoryId)

  return <Icon color={theme.color.info1} />
}
